// extracted by mini-css-extract-plugin
export var subtitle = "_cd-2";
export var title = "_cd-0";
export var titleNoWrap = "_cd-1";